export default "__VITE_ASSET__b033622c__"